export default {

    END_POINT_DEFAULT: process.env.VUE_APP_ENDPOINT_DEFAULT,
    END_POINT_PORTAL_CORPORATIVO: process.env.VUE_APP_END_POINT_PORTAL_CORPORATIVO,
    
    SSO_END_POINT: process.env.VUE_APP_ENDPOINT_SSO,

    SSO_REDIRECT_LOGIN_URL: process.env.VUE_APP_LOCATION_URL + "authorized/?",
    SSO_REDIRECT_LOGOUT_URL: "https://www.cna.com.br",

    SSO_CLIENT_ID: "corporativo-spa",
    SSO_RESPONSE_TYPE: "id_token token",
    SSO_SCOPE: "openid ssocna profile email",

    ACCESS_TOKEN: "AC_T_X857D",
    ID_TOKEN: "ID_T_D98SW",
    USER_INFO: "U_I_D8D5D",
    ID_STATE: "ID_S_852PL",

    CHAVE_IDENTIFICACAO_SISTEMA: "NOVO_JOBS",

    URL_PORTAL_CORPORATIVO: process.env.VUE_APP_PORTAL_CORPORATIVO,
    URL_DOWNLOAD: process.env.VUE_APP_ENDPOINT_DOWNLOAD + '/document/download/',

    URL_CANDIDATO: process.env.VUE_APP_URL_CANDIDATO,
}
